export default "__VITE_ASSET__CxIZpSNx__"